export type AuthTilePage =
  | 'login'
  | 'register'
  | 'reset-password-email'
  | 'reset-password'

const AUTH_TILE_PAGE_ORDER: AuthTilePage[] = [
  'login',
  'register',
  'reset-password-email',
  'reset-password'
]

const SEED_MODULUS = 2147483647
const SEED_MULTIPLIER = 48271

const waiterImageModules = import.meta.glob<string>(
  '../../../assets/images/people/*.png',
  {
    eager: true,
    import: 'default'
  }
)

const waiterImages = Object.entries(waiterImageModules)
  .sort(([firstPath], [secondPath]) => firstPath.localeCompare(secondPath))
  .map(([, src]) => src)

const getSeedFromDateKey = (dateKey: string) =>
  Array.from(dateKey).reduce(
    (seed, character) =>
      (seed * 31 + character.charCodeAt(0)) % SEED_MODULUS,
    7
  )

const createSeededRandom = (seed: number) => {
  let state = seed % SEED_MODULUS

  if (state <= 0) {
    state += SEED_MODULUS - 1
  }

  return () => {
    state = (state * SEED_MULTIPLIER) % SEED_MODULUS
    return state / SEED_MODULUS
  }
}

const getDailyImageOrder = (dateKey: string) => {
  const shuffledImages = [...waiterImages]
  const random = createSeededRandom(getSeedFromDateKey(dateKey))

  for (
    let currentIndex = shuffledImages.length - 1;
    currentIndex > 0;
    currentIndex -= 1
  ) {
    const swapIndex = Math.floor(random() * (currentIndex + 1))
    const currentImage = shuffledImages[currentIndex]

    shuffledImages[currentIndex] = shuffledImages[swapIndex]
    shuffledImages[swapIndex] = currentImage
  }

  return shuffledImages
}

const padDatePart = (datePart: number) => datePart.toString().padStart(2, '0')

export const getLocalDateKey = (date = new Date()) =>
  [
    date.getFullYear(),
    padDatePart(date.getMonth() + 1),
    padDatePart(date.getDate())
  ].join('-')

export const getMsUntilNextLocalDay = (date = new Date()) => {
  const nextDay = new Date(date)
  nextDay.setHours(24, 0, 0, 0)

  return Math.max(nextDay.getTime() - date.getTime(), 0)
}

export const getAuthTileImage = (
  page: AuthTilePage,
  dateKey: string
) => {
  const pageIndex = AUTH_TILE_PAGE_ORDER.indexOf(page)
  const dailyImageOrder = getDailyImageOrder(dateKey)

  return dailyImageOrder[pageIndex]
}
